define('componentSitemap',[
  'jquery',
  'responsive'
], function (
  $,
  responsive
) {
  $(function () {
    $('.show-link').click(function (e) {
      // get booleans for activated and trucks
      var activated = $(this).next().hasClass('active');
      var trucks = $(this).parent().parent().hasClass('two');
      var hybrids = $(this).parent().parent().hasClass('four');

      // block spacing for trucks and hybrids in tablet mode
      var spacing = (trucks == true) ? false : true;
      if (spacing == true) {
        spacing = (responsive() == 'md' && hybrids == true) ? false : true;
      }

      // kill current active
      $('.cell-sitemap').find('.active').removeClass('active');
      $('.cell-sitemap').find('.active').removeClass('active');
      // toggle based on active

      // toggle with special handling for vertical spacing
      if (!activated) {
        // add vertical space if it's not trucks
        if (spacing) {
          $('.one').addClass('open');
          $('.two').addClass('open');
          $('.three').addClass('open');
          $('.four').addClass('open');
        } else {
          // remove vertical space
          $('.one').removeClass('open');
          $('.two').removeClass('open');
          $('.three').removeClass('open');
          $('.four').removeClass('open');
        }
        // activate
        $(this).next().addClass('active');
        $(this).next().next().addClass('active');

        $(this).find('.icon-plus').addClass('active');
      } else {
        // remove vertical space
        $('.one').removeClass('open');
        $('.two').removeClass('open');
        $('.three').removeClass('open');
        $('.four').removeClass('open');
      }
    });
  });
});

